var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inForbiddenMap
    ? _c(
        "div",
        { staticClass: "forbidden-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "forbidden-card",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "forbidden-content" }, [
                _c("div", { staticClass: "exploration-info" }, [
                  _vm._v(
                    "\n        探索度：" +
                      _vm._s(_vm.currentExplorationCompletion) +
                      "% (" +
                      _vm._s(_vm.exploredCellCount) +
                      "/" +
                      _vm._s(_vm.gameState.mapSize * _vm.gameState.mapSize) +
                      ")\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "map-grid",
                    style: {
                      gridTemplateColumns: `repeat(${_vm.gameState.mapSize}, 1fr)`,
                    },
                  },
                  _vm._l(_vm.mapDisplay, function (cell, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: ["map-cell", _vm.getCellClass(cell)],
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getCellSymbol(cell)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "forbidden-buttons" }, [
                  _c(
                    "button",
                    {
                      attrs: { title: "向上移动" },
                      on: {
                        click: function ($event) {
                          return _vm.sendDirectCommand("up")
                        },
                      },
                    },
                    [_vm._v("↑")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { title: "向下移动" },
                      on: {
                        click: function ($event) {
                          return _vm.sendDirectCommand("down")
                        },
                      },
                    },
                    [_vm._v("↓")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { title: "向左移动" },
                      on: {
                        click: function ($event) {
                          return _vm.sendDirectCommand("left")
                        },
                      },
                    },
                    [_vm._v("←")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { title: "向右移动" },
                      on: {
                        click: function ($event) {
                          return _vm.sendDirectCommand("right")
                        },
                      },
                    },
                    [_vm._v("→")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { title: "神识扫描" },
                      on: {
                        click: function ($event) {
                          return _vm.sendDirectCommand("scan")
                        },
                      },
                    },
                    [_vm._v("扫描")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { title: "退出禁地" },
                      on: {
                        click: function ($event) {
                          return _vm.sendDirectCommand("exit")
                        },
                      },
                    },
                    [_vm._v("退出")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "forbidden-footer" }, [
                _c(
                  "button",
                  { staticClass: "close-btn", on: { click: _vm.closeModal } },
                  [_vm._v("关闭")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "forbidden-header" }, [
      _c("h3", [_vm._v("禁地地图")]),
      _vm._v(" "),
      _c("p", [_vm._v("探索禁地，寻找机缘与宝藏。")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "map-legend" }, [
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-symbol" }, [_vm._v("@")]),
        _vm._v(" 玩家位置"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-symbol" }, [_vm._v("·")]),
        _vm._v(" 未探索"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-symbol" }, [_vm._v("□")]),
        _vm._v(" 安全区域"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-symbol" }, [_vm._v("▲")]),
        _vm._v(" 危险区域"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-symbol" }, [_vm._v("☆")]),
        _vm._v(" 机缘区域"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-symbol" }, [_vm._v("★")]),
        _vm._v(" 宝藏位置"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }